import React from 'react';
import styled from 'styled-components';
import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
import { Modals } from './Modals';
import { LibraryNav } from './LibraryNav';
import { Fonts } from './Fonts';
import { Colors } from './Colors';
import { ComponentList } from './ComponentList';

const theme1 = {
	account: '#416ba9',
	support: '#8060a9',
	storage: '#008388',
	billing: '#a8ad00',
	Cool_Gray_Med_1: '#a2a9ad',
	Cool_Gray_Light_3: '#edefef',
};
const LibraryStyle = styled.div`
	display: flex;
	width: 100%;
	background-color: ${props => props.theme.Cool_Gray_Light_3};

	.main-content {
		width: 100%;
		padding: 30px;
		.ScrollbarsCustom-Track {
			right: -18px !important;
			top: 0px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.support} !important;
			width: 6px !important;
		}
		.ScrollbarsCustom-TrackY:before {
			border-left: none;
		}
		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 6px !important;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const Library = () => {
	return (
		<LibraryStyle>
			<LibraryNav />
			<ThemeProvider theme={theme1}>
				<div className='main-content'>
					<ScrollView>
						<Routes>
							<Route path='/' element={<ComponentList />} />
							<Route path='fonts' element={<Fonts />} />
							<Route path='colors' element={<Colors />} />
							{/* <Route path='buttons' element={<Buttons />} /> */}
							<Route path='modals' element={<Modals />} />
						</Routes>
					</ScrollView>
				</div>
			</ThemeProvider>
		</LibraryStyle>
	);
};
